import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from '@querodelivery/uni-react';
import styles from './location-card.module.scss';

interface LocationCardProps {
  icon: IconDefinition;
  label: string;
  name: string;
  address: string;
  addressTone: 'secondary' | 'supporting';
  href?: string;
}

export function LocationCard({
  icon,
  label,
  name,
  address,
  addressTone,
  href,
}: LocationCardProps) {
  const nameText: ReactNode = (
    <Text
      as="span"
      fontSize="md"
      fontWeight="bold"
      lineHeight="lg"
      tone="inherit"
      breakWord
    >
      {name}
    </Text>
  );

  return (
    <div className={styles.card}>
      <span className={styles.label}>
        <FontAwesomeIcon icon={icon} className={styles.icon} />
        <Text
          as="span"
          fontSize="sm"
          fontWeight="medium"
          lineHeight="lg"
          tone="supporting"
        >
          {label}
        </Text>
      </span>
      {href ? (
        <Link
          to={href}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.nameLink}
        >
          {nameText}
        </Link>
      ) : (
        <span className={styles.name}>{nameText}</span>
      )}
      <Text
        as="span"
        fontSize="md"
        fontWeight="semibold"
        lineHeight="lg"
        tone={addressTone}
        breakWord
      >
        {address}
      </Text>
    </div>
  );
}
